var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isOverlayVisible)?_c('div',{staticClass:"ui-overlay",class:{'off-navbar':_vm.isLayoutAsideHidden},on:{"click":_vm.click}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }